module.exports = __webpack_public_path__ + "img/logo_en.24c06b99.png";